import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El directorio de proveedores, dentro del grupo `_contabilidad`.
 *
 * Las cuatro funciones que administran un proveedor exigen `contador` o `administrador`, y los seis
 * escenarios de la feature 15 empiezan con «la contadora». No va en `_direccion`, que es del
 * administrador solo: ahi la contadora, que es quien administra el directorio, no entraria.
 */
export const rutaProveedores = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/proveedores',
  component: lazyRouteComponent(() => import('./proveedores-pantalla.js'), 'RutaProveedores'),
});
